import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import type { MailboxInfo } from 'owa-client-types';
import { getOrigin } from 'owa-url/lib/getOrigin';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import getRootVdirName from 'owa-url/lib/getRootVdirName';

/**
 * Checks if the request is for Consumer account and whether token fetch from MSAL is enabled.
 **/
export function isMsalEnabledForConsumerDomain(mailboxInfo?: MailboxInfo): boolean {
    return (
        isHostAppFeatureEnabled('msalTokenFetch') &&
        (mailboxInfo?.mailboxProvider == 'Outlook' || isConsumerDomain())
    );
}

/**
 * Checks if the request is for a consumer domain
 */
export function isConsumerDomain(): boolean {
    const origin = getOrigin().toLowerCase();
    return (
        origin.includes('live') &&
        !origin.includes('live-int.com') &&
        !isIndexedPathForShadowMailbox()
    );
}

// Returns true if url specified is an indexed path (e.g. /mail/1/) for accessing connected Shawdow Mailbox (Gmail)
export function isIndexedPathForShadowMailbox(): boolean {
    const path = getHostLocation()?.pathname;
    if (path) {
        const postVdirPath = path.split('/' + getRootVdirName() + '/')[1];
        if (postVdirPath) {
            const postVdirSegment = postVdirPath.split('/')[0];
            if (postVdirSegment && parseInt(postVdirSegment) == 1) {
                return true;
            }
        }
    }
    return false;
}
